import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'font-(family-name:--font-gotham) text-[#1F1F1F]',
    navigation:
      'max-lg:scrollbar-hidden fixed right-0 bottom-2 left-0 z-10 mx-auto transition-transform duration-500 ease-out max-lg:overflow-x-scroll md:flex md:justify-center lg:top-[670px] lg:bottom-auto'
  },
  variants: {
    isScrolled: {
      true: {
        navigation: 'lg:translate-y-[calc(100vh-670px-70px)]'
      },
      false: {
        navigation: 'lg:translate-y-0'
      }
    },
    isNearFooter: {
      true: {
        navigation: 'pointer-events-none opacity-0'
      },
      false: {
        navigation: 'opacity-100'
      }
    }
  }
});
